// constants
import { TestPanelMappingActionTypes } from './constants';
import { TestPanelMapping as TestPanelMappingData, TestPanelsListing } from 'src/types/testPanelMapping';

export type TestPanelMappingActionType = {
    type:
        | TestPanelMappingActionTypes.API_RESPONSE_SUCCESS
        | TestPanelMappingActionTypes.API_RESPONSE_ERROR
        | TestPanelMappingActionTypes.ADD_TEST_PANEL_MAPPING
        | TestPanelMappingActionTypes.EDIT_TEST_PANEL_MAPPING
        | TestPanelMappingActionTypes.GET_TEST_PANEL_MAPPING
        | TestPanelMappingActionTypes.GET_TEST_PANEL_MAPPINGS
        | TestPanelMappingActionTypes.GET_TEST_PANELS
        | TestPanelMappingActionTypes.RESET
        | TestPanelMappingActionTypes.RESET_SUCCESS
        | TestPanelMappingActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const testPanelMappingApiResponseSuccess = (
    actionType: string,
    data: TestPanelMappingData | TestPanelsListing | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): TestPanelMappingActionType => ({
    type: TestPanelMappingActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const testPanelMappingApiResponseError = (
    actionType: string,
    data: TestPanelMappingData | TestPanelsListing | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): TestPanelMappingActionType => ({
    type: TestPanelMappingActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addTestPanelMapping = (params: any): TestPanelMappingActionType => ({
    type: TestPanelMappingActionTypes.ADD_TEST_PANEL_MAPPING,
    payload: params,
});

export const editTestPanelMapping = (params: any): TestPanelMappingActionType => ({
    type: TestPanelMappingActionTypes.EDIT_TEST_PANEL_MAPPING,
    payload: params,
});

export const GetTestPanelMappings = (params: any): TestPanelMappingActionType => ({
    type: TestPanelMappingActionTypes.GET_TEST_PANEL_MAPPINGS,
    payload: params,
});

export const GetTestPanelMapping = (params: any): TestPanelMappingActionType => ({
    type: TestPanelMappingActionTypes.GET_TEST_PANEL_MAPPING,
    payload: params,
});

export const GetTestPanelListing = (params: any): TestPanelMappingActionType => ({
    type: TestPanelMappingActionTypes.GET_TEST_PANELS,
    payload: params,
});

export const resetTestPanelMapping = (): TestPanelMappingActionType => ({
    type: TestPanelMappingActionTypes.RESET,
    payload: {},
});

export const resetTestPanelMappingSuccess = (): TestPanelMappingActionType => ({
    type: TestPanelMappingActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetTestPanelMappingError = (): TestPanelMappingActionType => ({
    type: TestPanelMappingActionTypes.RESET_ERROR,
    payload: {},
});
